import { differenceInDays } from 'date-fns';

export default function daysLeft(endDate) {
    return differenceInDays(
        new Date(endDate),
        new Date(),
    );
}
